import storage from "good-storage"    //引入
const ADDRESS_DATAS ="__address_datas__"      //定义键值

import {
	getAreaAll,
	getArea,
	getCity,
	// editCartNum
} from '@/api/address'

const state = {
	area: [],
	province:[],
	city:[],
	tree:[],
	district:[]
}

const mutations = {
	SET_AREA:(state,list)=>{
		state.area = list
	},
	SET_PROVINCE:(state,list)=>{
		state.province = list
	},
	SET_CITY:(state,list)=>{
		state.city = list
	},
	SET_TREE:(state,tree)=>{
		state.tree = tree
	},
	SET_DISTRICT:(state,list)=>{
		state.district = list
	},
	_SET:(state,o)=>{
		state.area = o.area
		state.province = o.province
		state.city = o.city
		state.district = o.district
	},
	// SET_CART_COUNT: (state, count) => {
	// 	state.cartCount = count
	// }
}

const actions = {
	load({commit}){
		let o = storage.get(ADDRESS_DATAS,{});
		// console.log(9999,0)
		if(o.area){
			// console.log(111,o)
			commit('_SET',o)
		}else{
			console.log(222333333)
			this.dispatch("area/load_area")
		}
		// console.log(state);
		// if(state.province.length ==0){
		// 	let o = storage.get(ADDRESS_DATAS,{});
		// }
	},
	load_area({
		commit
	},param){
		return new Promise((resolve, reject) => {
			return getAreaAll({
				}).then(res => {
					console.log(2222222);
					commit('SET_AREA', res.data)
					let province = [];
					let city = [];
					let district = [];
					res.data.forEach((v,i)=>{
						if(v.level == 1){
							province.push(v);
						}
						if(v.level ==2){
							city.push(v)
						}
						if(v.level ==3){
							district.push(v)
						}
					})
					city.forEach((v,i)=>{
						v.child = [];
						district.forEach((vv,ii)=>{
							if(vv.pid == v.id){
								
								v.child.push(vv)
							}
						})
						// console.log(11111,v.child)
					})
					// console.log(city);
					
					province.forEach((v,i)=>{
						v.child = [];
						city.forEach((vv,ii)=>{
							if(vv.pid == v.id){
								v.child.push(vv)
							}
						})
					})
					// console.log(province)
					
					commit('SET_PROVINCE', province)
					commit('SET_CITY', city)
					commit('SET_DISTRICT', district)
					// console.log(state)
					storage.set(ADDRESS_DATAS,state);
					resolve(res)
				})
				.catch(err => {
					reject(err)
				})
		})
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
